import {useAppState} from "@/store";
import {ALLOWED_SIZES, LOCATION_TYPE_TO_SIZE_MAP, PROPERTY_TYPES_WITH_OPT_SIZE} from "@/constants";
import Select from "@/components/fields/Select";
import Input from "@/components/fields/Input";

export default function PropertySize({stateKey}) {

    const {state, setState} = useAppState()

    const sizes = Object.keys(LOCATION_TYPE_TO_SIZE_MAP).includes(state[stateKey]?.propertyType) ?
        ALLOWED_SIZES[LOCATION_TYPE_TO_SIZE_MAP[state[stateKey]?.propertyType]]
        : ALLOWED_SIZES['SquareFeet'];


    const description = "🧠 Helps our Smart Move System™ create your perfect crew size"

    const handleChange = (v) => {
        setState((s) => {
            s[stateKey].size = v
        })
    }

    if (!state[stateKey]?.propertyType) {
        return (
            <Select
                label={"Size"}
                name={`${stateKey}.size`}
                value={""}
                description={description}
                placeholder={"-- Select Property Type --"}
                required
            />
        )
    }

    if (!!sizes && !(sizes instanceof RegExp)) {
        return (
            <Select
                label={"Size"}
                name={`${stateKey}.size`}
                options={sizes}
                value={state[stateKey]?.size || ''}
                description={description}
                onChange={handleChange}
                placeholder={"-- Select Size --"}
                required={!PROPERTY_TYPES_WITH_OPT_SIZE.includes(state[stateKey]?.propertyType)}
            />
        )
    } else {
        return (
            <Input
                label={"Size"}
                type={"number"}
                name={`${stateKey}.size`}
                value={state[stateKey]?.size || ''}
                placeholder={"Enter square footage (approximate)"}
                description={description}
                onChange={(v) => handleChange(v.replace(/^0+/, ''))}
                min={1}
                required
            />
        )
    }
}
